// import { Card, CardBody, CardHeader } from '@components/card/card';
// import { useTranslation } from 'react-i18next';
// import { paymentTypeEnum } from '../paymentTypeEnum';
// import { useEffect, useState } from 'react';
// import type { APIResponse } from '@store/Shared/shared';
// import type { PaymentsByIdModels } from '@store/Finance/AP/ApPayments/ApPaymentsModels';
// import { ntxAPI } from '@API/axiosNeatex';
// import type { ApInvoicesModels } from '@store/Finance/AP/ApInvoices/ApInvoicesModels';

// const PaymentDetailsCard = ({ paymentType, Id, scheduleCount }: any) => {
//   const [prePaymentData, setprePaymentData] = useState<any>(null);
//   const [creditMemoData, setCreditMemoData] = useState<any>(null);
//   const [loading, setLoading] = useState<boolean>(false);
//   const [error, setError] = useState<string | null>(null);

//   // استدعاء البيانات بناءً على النوع والمعرف
//   useEffect(() => {
//     const fetchData = async () => {
//       // debugger
//       if (!Id) return;
//       setLoading(true);
//       setError(null);
//       try {
//         // if (paymentType === paymentTypeEnum.ApplyDebitMemo) {
//         if ([paymentTypeEnum.ApplyDebitMemo, paymentTypeEnum.Refund].includes(paymentType)) {
//           const { data } = await ntxAPI.get<APIResponse<ApInvoicesModels>>(`Ap/GetApInvoicesById?Id=${Id}`);
//           if (data?.succeeded) {
//             setCreditMemoData(data.data);
//           } else {
//             setError(data.message || 'فشل في جلب بيانات إشعار المدين');
//           }
//         } else if (paymentType === paymentTypeEnum.ApplyPrePayment) {
//           const { data } = await ntxAPI.get<APIResponse<PaymentsByIdModels>>(`Ap/GetApPaymentsById?Id=${Id}`);
//           if (data?.succeeded) {
//             setprePaymentData(data.data);
//           } else {
//             setError(data.message || 'فشل في جلب بيانات الدفعة المقدمة');
//           }
//         }
//       } catch (err: any) {
//         setError(err.message || 'حدث خطأ أثناء جلب البيانات');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [paymentType, Id]);

//   if (!Id) return null;

//   if (loading) {
//     return (
//       <div className='col-12'>
//         <Card className='border-warning'>
//           <CardBody className='text-center'>
//             <div className='spinner-border spinner-border-sm me-2'></div>
//             جاري التحميل...
//           </CardBody>
//         </Card>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className='col-12'>
//         <Card className='border-danger'>
//           <CardBody className='text-center text-danger'>
//             <i className='fas fa-exclamation-triangle me-2'></i>
//             خطأ في تحميل البيانات: {error}
//           </CardBody>
//         </Card>
//       </div>
//     );
//   }

//   // بيانات اشعار المدين
//   // if (paymentType === paymentTypeEnum.ApplyDebitMemo && creditMemoData) {
//   if ([paymentTypeEnum.ApplyDebitMemo, paymentTypeEnum.Refund].includes(paymentType) && creditMemoData) {
//     return (
//       <div className='shadow-sm border border-warning mb-4 '>
//         {/* <Card className='border-warning mb-4'> */}
//         <div className='card-header bg-warning bg-opacity-25 d-flex justify-content-between align-items-center'>
//           <h6 className='mb-0'>
//             <i className='fas fa-rotate-left me-2'></i>
//             فاتورة المردود المختارة
//             {/* <span className='badge bg-warning ms-2'>إشعار مدين</span> */}
//           </h6>
//           {/* <div>
//               <span className='badge bg-theme me-2'>فواتير مطبقة: {scheduleCount || 0}</span>
//               <span className='badge bg-success'>
//                 المبلغ: {Number(creditMemoData.remainingAmount).toLocaleString()}
//               </span>
//             </div> */}
//         </div>

//         <div className='card-body p-0'>
//           <div className='table-responsive'>
//             <table className='table table-hover mb-0'>
//               <thead className='table-actived fw-bold'>
//                 <tr>
//                   <th className='text-center small'>رقم الفاتورة</th>
//                   {/* <th className='text-center small'>رقم الدفع</th> */}
//                   <th className='text-center small'>تاريخ الفاتورة</th>
//                   <th className='text-center small'>المبلغ </th>
//                   <th className='text-center small'>النوع</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   <td className='text-center align-middle'>
//                     <span className='fw-bold'>{creditMemoData.invoiceNum}</span>
//                   </td>
//                   {/* <td className='text-center align-middle'>{creditMemoData.paymentNum}</td> */}
//                   <td className='text-center align-middle'>{creditMemoData.invoiceDate?.split('T')[0]}</td>
//                   <td className='text-center align-middle'>
//                     <span className='fw-bold text-success'>
//                       {Number(creditMemoData.invoiceAmount).toLocaleString()}
//                     </span>
//                   </td>
//                   <td className='text-center align-middle'>
//                     <span className='badge bg-warning'>إشعار دائن</span>
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* <div className='card-footer d-flex justify-content-between align-items-center'>
//             <div className='text-muted small'>عرض 1 من 1 فاتورة مردود</div>
//             <div className='text-theme fw-bold fs-5'>
//               المجموع الكلي: {Number(creditMemoData.invoiceAmount).toLocaleString()}
//             </div>
//           </div> */}
//         {/* </Card> */}
//       </div>
//     );
//   }

//   // بيانات الدفعة المقدمة
//   // المبلغ المستخدم من الدفعة المقدمة
//   // const usedAdvanceAmount = prePaymentData?.invoicePaymentList?.reduce(
//   //   (total: any, item: any) => total + (item.amount || 0),
//   //   0
//   // );
//   // // المبلغ المتبقي
//   // const remainingAdvanceAmount = (prePaymentData?.amount || 0) - usedAdvanceAmount;

//   if (paymentType === paymentTypeEnum.ApplyPrePayment && prePaymentData) {
//     return (
//       <div className='col-12'>
//         <Card className='border-info mb-4'>
//           <div className='card-header d-flex justify-content-between align-items-center'>
//             <h6 className='mb-0'>
//               <i className='fas fa-money-bill-wave me-2'></i>
//               الدفعة المقدمة المختارة
//               <span className='badge bg-info ms-2'>دفعة مقدمة</span>
//             </h6>
//             {/* <div>
//               <span className='badge bg-theme me-2'>الحالة: {prePaymentData.status}</span>
//               <span className='badge bg-success'>المبلغ: {Number(prePaymentData.amount).toLocaleString()}</span>
//             </div> */}
//           </div>

//           <div className='card-body p-0'>
//             <div className='table-responsive'>
//               <table className='table table-hover mb-0'>
//                 <thead className='table-actived fw-bold'>
//                   <tr>
//                     <th className='text-center small'>رقم سند الدفع</th>
//                     <th className='text-center small'>التاريخ</th>
//                     <th className='text-center small'>المبلغ</th>
//                     <th className='text-center small'>المبلغ المتبقي</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr>
//                     <td className='text-center align-middle'>
//                       <span className='fw-bold'>{prePaymentData.code}</span>
//                     </td>
//                     <td className='text-center align-middle'>{prePaymentData.paymentDate?.split('T')[0]}</td>
//                     <td className='text-center align-middle'>
//                       <span className='fw-bold text-primary'>{Number(prePaymentData.amount).toLocaleString()}</span>
//                     </td>
//                     <td className='text-center align-middle'>
//                       <span className='fw-bold text-warning'>
//                         {/* {Number(prePaymentData.remainingAmount).toLocaleString()} */}
//                         {/* {remainingAdvanceAmount} */}
//                         ---
//                       </span>
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           <div className='card-footer d-flex justify-content-between align-items-center'>
//             <div className='text-muted small'>عرض 1 من 1 دفعة مقدمة</div>
//             <div className='text-theme fw-bold fs-5'>
//               المبلغ الإجمالي: {Number(prePaymentData.amount).toLocaleString()}
//             </div>
//           </div>
//         </Card>
//       </div>
//     );
//   }

//   return null;
// };

// export default PaymentDetailsCard;

import { Card, CardBody, CardHeader } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import { paymentTypeEnum } from '../paymentTypeEnum';
import { useEffect, useState } from 'react';
import type { APIResponse } from '@store/Shared/shared';
import type { PaymentsByIdModels } from '@store/Finance/AP/ApPayments/ApPaymentsModels';
import { ntxAPI } from '@API/axiosNeatex';
import type { ApInvoicesModels } from '@store/Finance/AP/ApInvoices/ApInvoicesModels';

const PaymentDetailsCard = ({ paymentType, Id, scheduleCount }: any) => {
  const [prePaymentData, setprePaymentData] = useState<any>(null);
  const [creditMemoData, setCreditMemoData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  // استدعاء البيانات بناءً على النوع والمعرف
  useEffect(() => {
    const fetchData = async () => {
      if (!Id) return;
      setLoading(true);
      setError(null);
      try {
        // debugger
        if ([paymentTypeEnum.ApplyDebitMemo, paymentTypeEnum.Refund].includes(paymentType)) {
          const { data } = await ntxAPI.get<APIResponse<ApInvoicesModels>>(`Ap/GetApInvoicesById?Id=${Id}`);
          if (data?.succeeded) {
            setCreditMemoData(data.data);
          } else {
            setError(data.message || 'فشل في جلب بيانات إشعار المدين');
          }
        } 
        // ← تعديل: إضافة PrePaymentRefund إلى الشرط الذي يجلب بيانات الدفعة المسبقة
        else if ([paymentTypeEnum.ApplyPrePayment, paymentTypeEnum.PrePaymentRefund].includes(paymentType)) {
          const { data } = await ntxAPI.get<APIResponse<PaymentsByIdModels>>(`Ap/GetApPaymentsById?Id=${Id}`);
          if (data?.succeeded) {
            setprePaymentData(data.data);
          } else {
            setError(data.message || 'فشل في جلب بيانات الدفعة المقدمة');
          }
        }
      } catch (err: any) {
        setError(err.message || 'حدث خطأ أثناء جلب البيانات');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [paymentType, Id]);

  console.log(creditMemoData);
  

  if (!Id) return null;

  if (loading) {
    return (
      <div className='col-12'>
        <Card className='border-warning'>
          <CardBody className='text-center'>
            <div className='spinner-border spinner-border-sm me-2'></div>
            جاري التحميل...
          </CardBody>
        </Card>
      </div>
    );
  }

  if (error) {
    return (
      <div className='col-12'>
        <Card className='border-danger'>
          <CardBody className='text-center text-danger'>
            <i className='fas fa-exclamation-triangle me-2'></i>
            خطأ في تحميل البيانات: {error}
          </CardBody>
        </Card>
      </div>
    );
  }

  // بيانات إشعار المدين / المردود (لا تغيير هنا)
  if ([paymentTypeEnum.ApplyDebitMemo, paymentTypeEnum.Refund].includes(paymentType) && creditMemoData) {
    return (
      <div className='shadow-sm border border-warning mb-4 '>
        <div className='card-header bg-warning bg-opacity-25 d-flex justify-content-between align-items-center p-2'>
          <h6 className='mb-0'>
            <i className='fas fa-rotate-left me-2'></i>
            فاتورة المردود المختارة
          </h6>
        </div>

        <div className='card-body p-0'>
          <div className='table-responsive'>
            <table className='table table-hover mb-0'>
              <thead className='table-actived fw-bold'>
                <tr>
                  <th className='text-center small'>رقم الفاتورة</th>
                  <th className='text-center small'>تاريخ الفاتورة</th>
                  <th className='text-center small'>المبلغ </th>
                  <th className='text-center small'>النوع</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className='text-center align-middle'>
                    <span className='fw-bold'>{creditMemoData.invoiceNum || '--'}</span>
                  </td>
                  <td className='text-center align-middle'>{creditMemoData.invoiceDate?.split('T')[0]}</td>
                  <td className='text-center align-middle'>
                    <span className='fw-bold text-success'>
                      {Number(creditMemoData.invoiceAmount).toLocaleString()}
                    </span>
                  </td>
                  <td className='text-center align-middle'>
                    <span className='badge bg-warning'>إشعار دائن</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  // ← تعديل رئيسي: عرض بيانات الدفعة المسبقة لكل من ApplyPrePayment و PrePaymentRefund
  // مع تمييز مختلف للاسترداد (لون برتقالي، أيقونة استرداد، نصوص مختلفة)
  if ([paymentTypeEnum.ApplyPrePayment, paymentTypeEnum.PrePaymentRefund].includes(paymentType) && prePaymentData) {
    const isRefund = paymentType === paymentTypeEnum.PrePaymentRefund;

    return (
      <div className='col-12'>
        <Card className={`mb-4 ${isRefund ? 'border-orange' : 'border-info'}`}>
          <div className='card-header d-flex justify-content-between align-items-center'>
            <h6 className='mb-0'>
              <i className={`fas ${isRefund ? 'fa-undo-alt' : 'fa-money-bill-wave'} me-2`}></i>
              {isRefund ? 'الدفعة المقدمة المستردة' : 'الدفعة المقدمة المختارة'}
              <span className={`badge ${isRefund ? 'bg-theme' : 'bg-theme'} ms-2`}>
                {isRefund ? 'استرداد دفعة مقدمة' : 'دفعة مقدمة'}
              </span>
            </h6>
          </div>

          <div className='card-body p-0'>
            <div className='table-responsive'>
              <table className='table table-hover mb-0'>
                <thead className='table-actived fw-bold'>
                  <tr>
                    <th className='text-center small'>رقم سند الدفع</th>
                    <th className='text-center small'>التاريخ</th>
                    <th className='text-center small'>مبلغ الدفعة</th>
                    {/* <th className='text-center small'>الرصيد المتبقي</th> */}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className='text-center align-middle'>
                      <span className='fw-bold'>{prePaymentData.code}</span>
                    </td>
                    <td className='text-center align-middle'>{prePaymentData.paymentDate?.split('T')[0]}</td>
                    <td className='text-center align-middle'>
                      <span className='fw-bold text-primary'>{Number(prePaymentData.amount).toLocaleString()}</span>
                    </td>
                    {/* <td className='text-center align-middle'>
                      <span className={`fw-bold ${isRefund ? 'text-orange' : 'text-warning'}`}>
                        {Number(prePaymentData.remainingAmount || 0).toLocaleString()}
                      </span>
                    </td> */}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className='card-footer d-flex justify-content-between align-items-center'>
            <div className='text-muted small'>عرض 1 من 1 دفعة مسبقة</div>
            <div className='text-theme fw-bold fs-5'>
              المبلغ الإجمالي: {Number(prePaymentData.amount).toLocaleString()}
            </div>
          </div>
        </Card>
      </div>
    );
  }

  return null;
};

export default PaymentDetailsCard;
